import script from "./ModalPartidasActivas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalPartidasActivas.vue?vue&type=script&setup=true&lang=ts"

import "./ModalPartidasActivas.vue?vue&type=style&index=0&id=3b09a22c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b09a22c"]])

export default __exports__